import {ObjectDTO} from '../../object-dto';

export default class ModeleConditionnementPlcDTO extends ObjectDTO {

  libelle: string;

  code: string;

}
